export default __webpack_public_path__ + "static/img18-a4cd89ba8c101635b11833ee568efaaa.png";